import CryptoJS from 'crypto-js';
export const encriptar = (texto,clave)=>
{
    return CryptoJS.AES.encrypt(texto, clave).toString();
}
export const desEncriptar = (texto,clave)=>
{
    if (!texto || texto === '' || texto === 'null' || texto === 'undefined') {
        return null;
    }
    try {
        const decrypted = CryptoJS.AES.decrypt(texto, clave).toString(CryptoJS.enc.Utf8);
        if (!decrypted) {
            return null;
        }
        return decrypted;
    } catch (error) {
        console.error('Error al desencriptar:', error);
        return null;
    }
}